import ApiService from "@/core/services/api.service";
import {SET_SNACK} from "@/core/services/store/snackbar.module";

// action types
export const PAGES_LIST = "pages_list";
export const PAGES_SIMPLE_LIST = "pages_simple_list";
export const CREATE_PAGE = "create_page";
export const UPDATE_PAGE = "update_page";
export const UPDATE_PAGE_STATUS = "UPDATE_PAGE_STATUS";
export const DELETE_PAGE = "delete_page";
export const GET_PAGE_DETAILS = "get_page_details";
export const CLEAR_PAGE_ERRORS = "clearPageErrors";

// mutation types
export const SET_PAGE_ERROR = "setPageError";
export const REMOVE_PAGE_ERRORS = "removePageErrors";

const state = {
    errors: null
};


const actions = {
    [PAGES_LIST](context, payload) {
        ApiService.setHeader();
        return new Promise(resolve => {
            ApiService.datatable("api/pages?" + payload.q + payload.columns.join(''))
                .then(({data}) => {
                    if (data._metadata.outcomeCode === 0) {
                        resolve(data);
                    } else {
                        this.dispatch(SET_SNACK, {clr: 'error', msg: data._metadata.message});
                        context.commit(SET_PAGE_ERROR, data.errors);
                    }
                })
                .catch(({response}) => {
                    context.commit(SET_PAGE_ERROR, response.errors);
                });
        });
    },
    [PAGES_SIMPLE_LIST]() {
        ApiService.setHeader();
        return new Promise(resolve => {
            ApiService.datatable("api/pagessimple")
                .then(({data}) => {
                    if (data._metadata.outcomeCode === 0) {
                        resolve(data);
                    } else {
                        this.dispatch(SET_SNACK, {clr: 'error', msg: data._metadata.message});
                    }
                });
        });
    },
    [GET_PAGE_DETAILS](context, id) {
        ApiService.setHeader();
        return new Promise(resolve => {
            ApiService.get("api/getpagedetail", id)
                .then(({data}) => {
                    if (data._metadata.outcomeCode === 0) {
                        resolve(data);
                    } else {
                        this.dispatch(SET_SNACK, {clr: 'error', msg: data._metadata.message});
                        context.commit(SET_PAGE_ERROR, data.errors);
                    }
                })
                .catch(({response}) => {
                    context.commit(SET_PAGE_ERROR, response.errors);
                });
        });
    },
    [CREATE_PAGE](context, payload) {
        return new Promise(resolve => {
            return ApiService.post("api/createpage", payload.data).then(({data}) => {
                if (data._metadata.outcomeCode === 0) {
                    this.dispatch(SET_SNACK, {clr: 'success', msg: data._metadata.message});
                    resolve(data);
                } else {
                    this.dispatch(SET_SNACK, {clr: 'error', msg: data._metadata.message});
                    context.commit(SET_PAGE_ERROR, data.errors);
                }
            })
                .catch(({response}) => {
                    context.commit(SET_PAGE_ERROR, response.errors);
                });
        });
    },
    [UPDATE_PAGE](context, payload) {
        return new Promise(resolve => {
            return ApiService.update("api/updatepage", payload.slug, payload.data).then(({data}) => {
                if (data._metadata.outcomeCode === 0) {
                    this.dispatch(SET_SNACK, {clr: 'success', msg: data._metadata.message});
                    resolve(data);
                } else {
                    this.dispatch(SET_SNACK, {clr: 'error', msg: data._metadata.message});
                    context.commit(SET_PAGE_ERROR, data.errors);
                }
            })
                .catch(({response}) => {
                    context.commit(SET_PAGE_ERROR, response.errors);
                });
        });
    },
    [UPDATE_PAGE_STATUS](context, payload) {
        return new Promise(resolve => {
            return ApiService.update("api/updatepagestatus", payload.slug, payload.data).then(({data}) => {
                if (data._metadata.outcomeCode === 0) {
                    this.dispatch(SET_SNACK, {clr: 'success', msg: data._metadata.message});
                    resolve(data);
                } else {
                    this.dispatch(SET_SNACK, {clr: 'error', msg: data._metadata.message});
                    context.commit(SET_PAGE_ERROR, data.errors);
                }
            })
                .catch(({response}) => {
                    context.commit(SET_PAGE_ERROR, response.errors);
                });
        });
    },
    [DELETE_PAGE](context, payload) {
        return new Promise(resolve => {
            return ApiService.post("api/deletepage", payload).then(({data}) => {
                if (data._metadata.outcomeCode === 0) {
                    this.dispatch(SET_SNACK, {clr: 'success', msg: data._metadata.message});
                    resolve(data);
                } else {
                    this.dispatch(SET_SNACK, {clr: 'error', msg: data._metadata.message});
                    context.commit(SET_PAGE_ERROR, data.errors);
                }
            })
                .catch(({response}) => {
                    context.commit(SET_PAGE_ERROR, response.errors);
                });
        });
    },
    [CLEAR_PAGE_ERRORS](context) {
        context.commit(REMOVE_PAGE_ERRORS);
    },
};

const mutations = {
    [SET_PAGE_ERROR](state, error) {
        state.errors = error;
    },
    [REMOVE_PAGE_ERRORS](state) {
        state.errors = {};
    }
};

export default {
    state,
    actions,
    mutations
};
